import {Cargo, TerminalRelease, TerminalReleaseState} from "~/apps/packages/warehouse-closure/queries";
import {ArrayElement} from "~/types";


export function humanizeTerminalReleaseState(state: TerminalReleaseState) {
    switch (state) {
        case "Новая":
        case "Проверки пройдены":
        case "Проверки не пройдены":
        case "ТД Присвоены":
        case "Подготовка Коммерческого Акта":
        case "К закрытию":
            return "В работе";
        case "Отклонена сервисным центром":
            return "Ошибка"
        case "Закрыта":
            return "Закрыта";
        case "Отозвана клиентом":
            return "Отменена";
    }
}


export function canCancelTerminalRelease(terminalRelease: Pick<TerminalRelease, "State">) {
    return ["Новая", "Проверки пройдены", "Проверки не пройдены"].includes(terminalRelease["State"]);
}

export function canRecoveryTerminalRelease(terminalRelease: Pick<TerminalRelease, "State">) {
    return ["Отозвана клиентом", "Отклонена сервисным центром"].includes(terminalRelease["State"]);
}


export function getTerminalReleaseStatusColor(status: TerminalRelease["State"]) {
    const COLOR_MAP: {[key in ReturnType<typeof humanizeTerminalReleaseState>]: any} = {
        "В работе": "#28BA2C",
        "Ошибка": "#E53328",
        "Закрыта": "#009ACF",
        "Отменена": "#6E798C",
    }
    return COLOR_MAP[humanizeTerminalReleaseState(status)];
}


export function humanizeCargoTag(tag: keyof Cargo["tags"]): string {
    switch (tag) {
        case "agentRelease":
            return "Откреплен"
        case "customsControl":
            return "Таможенный";
        case "terminalRelease":
            return "Склад закрыт";
        default:
            return tag;
    }
}